import React from 'react';
import { Breadcrumb, Layout, notification, Modal } from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { graphql, withApollo } from 'react-apollo';

import Loading from '../../../common/Loading';

import FormTipoAtencion from './FormTipoAtencion';

import getTipoAtenciones from '../../../../graphql/querys/otros/getTipoAtenciones.graphql';
import insertTipoAtencion from '../../../../graphql/mutations/otros/insertTipoAtencion.graphql';
import { errorService } from '../../../../graphql/utils/utils';

const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

@graphql(insertTipoAtencion, {
  name: 'insertTipoAtencion',
  options: {
    refetchQueries: [{ query: getTipoAtenciones }],
  },
})
class CrearTipoAtencion extends React.Component {
  constructor(props) {
    super(props);

    // console.log("Entre al constructor");

    this.state = {
      tipo_atencion: {
        nombre: '',
      },
      step: 0,
      loading: false,
    };
  }

  guardarTipoAtencion = tipo_atencion => {
    this.props
      .insertTipoAtencion({
        variables: {
          nombre: tipo_atencion.nombre,
        },
      })
      // eslint-disable-next-line no-unused-vars
      .then(res => {
        notification.success({
          message: 'Creacion Correcta',
          description:
            'Se ha registrado el nuevo tipo de atencion de forma exitosa',
        });

        this.props.history.push('/admin/otros/tipo_atencion');
      })
      .catch(err => {
        console.log('Error en la creacion del tipo de atencion');
        console.log(err);
        errorService(err, {
          nombre: tipo_atencion.nombre,
        });

        Modal.error({
          title: 'Error en la creacion del tipo de atencion',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  };

  onCancel = () => {
    this.setState({
      fase: 0,
    });
  };

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Tipo de Atencion</Breadcrumb.Item>
          <Breadcrumb.Item>Crear</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Crear Tipo de Atencion
          </h2>
          <br />
          <div style={estiloContent}>
            <FormTipoAtencion
              className="formularios"
              onSubmit={this.guardarTipoAtencion}
              onAnterior={() =>
                this.props.history.push('/admin/otros/tipo_atencion')
              }
              datos={this.state.tipo_atencion}
            />
          </div>
        </Layout>
      </div>
    );
  }
}

export default withApollo(CrearTipoAtencion);
